import getBasePath from '@/utils/path'
import { StationApi } from '@clients/termine'

const basePath = getBasePath() + '/termine/api'

export function createStationAPIClient (): StationApi {
  return new StationApi({ basePath })
}
